import { Route, Routes } from "react-router-dom";

import { useAppSelector } from "store";

import AppStyledDashboard from "components/AppStyledDashboard";
import PersistentToken from "components/app/PersistentToken";
import Challenge from "components/challenges/Challenge";
import PublicChallenges from "components/challenges/PublicChallenges";
import Entry from "components/entry/Entry";
import IdeaNoUser from "components/ideas/IdeaNoUser";
import { Download } from "components/lib/Download";
import AgreeToTerms from "components/lib/Entry/AgreeToTerms";
import { Invitation } from "components/lib/Invitations/Invitation";
import UserUnsubscribe from "components/users/Unsubscribe";

import CustomPage from "./CustomPage";

const NonUserSwitch = () => {
  const user = useAppSelector((state) => state.user);
  const showLogin = useAppSelector((state) => state.auth.showLogin);
  const gettingUserError = useAppSelector((state) => state.auth.errorMessage);

  if (!user && (showLogin || !gettingUserError)) {
    return (
      <Routes>
        <Route
          path="agree-terms"
          element={<AppStyledDashboard content={<AgreeToTerms />} />}
        />
        <Route path="unsubscribe" element={<UserUnsubscribe />} />
        <Route
          path="invitations"
          element={
            <AppStyledDashboard excludeWelcomeText content={<Invitation />} />
          }
        />
        <Route
          path="download"
          element={
            <AppStyledDashboard excludeWelcomeText content={<Download />} />
          }
        />
        <Route path="ideas/:id" element={<IdeaNoUser />} />
        <Route
          path="challenges/public"
          element={
            <AppStyledDashboard
              fluid
              excludeWelcomeText
              content={<PublicChallenges />}
            />
          }
        />
        <Route path="challenges/:id/*" element={<Challenge />} />
        <Route
          path="join/:token"
          element={
            <AppStyledDashboard
              scrolling={false}
              excludeWelcomeText
              content={<PersistentToken />}
            />
          }
        />
        <Route path="custom-pages/:pageId" element={<CustomPage />} />
        <Route path="*" element={<Entry />} />
      </Routes>
    );
  }
  return null;
};

export default NonUserSwitch;
